import React, {Component} from 'react'
import styled from "styled-components"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import SelectedProvider from "manager/views/components/Settlement/SelectedProviderStatus/SelectedProvider"
import OpenNewOrder from "manager/views/components/Settlement/SelectedProviderStatus/OpenNewOrder"
import InviteProvider from "manager/views/components/Settlement/SelectedProviderStatus/InviteProvider"
import {
  DESKTOP_BREAKPOINT,
  ORDER_REJECTED_SUPPORT_URL,
  ORDER_STATUS
} from "manager/views/components/Settlement/constants"
import {
  selectAgentOpId,
  selectLatestQualiaOrder,
  selectProviderReferralSent,
  selectSelectedProviderIsQualiaSupported, selectTransactionOpId
} from "manager/selectors/referral_selectors"
import BackLink from "manager/views/components/Settlement/Common/BackLink"
import PlaceOrder from "manager/views/components/Settlement/SelectedProviderStatus/PlaceOrder"
import InviteProviderInput from "manager/views/components/Settlement/SelectedProviderStatus/InviteProviderInput"
import OrderStatus from "manager/views/components/Settlement/SelectedProviderStatus/OrderStatus";
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard";
import { goToLink } from 'common/util/helper'
import { selectManagerOpenUrlFeatureEnabled } from "manager/selectors/manager_selectors"
import {segmentEventTracker} from "common/analytics"

const SelectedSettlementProviderStatusContainer = styled.div`
  color: #4A4A4A;
  font-family: "Circular", sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #F1F1F4;

  a {
    color: #0588DD;
  }
`
const LinkA = styled.a`
  color: #0588DD;
  @media screen and ${DESKTOP_BREAKPOINT} {
    padding-left: 35px;
  }
`

/**
 * When a settlement provider has been previously selected, this card offers secondary actions (if appropriate)
 * and reports status of those actions.
 */
class SelectedSettlementProviderStatus extends Component {
  state = {
    inviteProviderInputView : false,
    placeOrderView: false,
  }

  setInviteProviderInputView = (inviteProviderInputView) => {
    this.setState({inviteProviderInputView})
  }

  setPlaceOrderView = (placeOrderView) => {
    this.setState({placeOrderView})
  }

  render() {
    const {isQualiaSupported, referral_sent, qualia_order, openUrlFeatureEnabled, transaction_op_id, agent_op_id} = this.props

    if (this.state.placeOrderView) {
      return (
        <SelectedSettlementProviderStatusContainer>
          <PlaceOrder onClose={() => this.setPlaceOrderView(false)}/>
        </SelectedSettlementProviderStatusContainer>
      )
    }

    if (this.state.inviteProviderInputView) {
      return (
        <SelectedSettlementProviderStatusContainer>
          <InviteProviderInput setInviteProviderInputView={this.setInviteProviderInputView}/>
        </SelectedSettlementProviderStatusContainer>
      )
    }

    if (!isQualiaSupported) {
      let eventName = null
      if (referral_sent === true) {
        eventName =  "Post-Provider-Invited Viewed"
      } else if (referral_sent === false) {
        eventName = "Invite-Provider Viewed"
      }
      segmentEventTracker(eventName, {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
    }

    return (
      <SelectedSettlementProviderStatusContainer>
        <SelectedProvider/>
        {!qualia_order && <OpenNewOrder setPlaceOrderView={this.setPlaceOrderView}/>}
        {qualia_order && <OrderStatus/>}
        {qualia_order && qualia_order.status === ORDER_STATUS.CANCELED &&
          <OpenNewOrder setPlaceOrderView={this.setPlaceOrderView}/>
        }
        {!isQualiaSupported && !referral_sent && (
          <InviteProvider setInviteProviderInputView={this.setInviteProviderInputView}/>
        )}
        {qualia_order && qualia_order.status === ORDER_STATUS.REJECTED &&
        <SettlementCard style={{ padding: "20px" }}>
          <LinkA onClick={() => goToLink(openUrlFeatureEnabled, ORDER_REJECTED_SUPPORT_URL)}>Why was my order
            rejected?</LinkA>
        </SettlementCard>
        }
      </SelectedSettlementProviderStatusContainer>
    )
  }

}

const selector = createStructuredSelector({
  isQualiaSupported: selectSelectedProviderIsQualiaSupported,
  referral_sent: selectProviderReferralSent,
  qualia_order: selectLatestQualiaOrder,
  openUrlFeatureEnabled: selectManagerOpenUrlFeatureEnabled,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(SelectedSettlementProviderStatus)
